export default "__VITE_ASSET__23c6b2d3__"